export class StockInHandStatus {
    constructor(public StockInHand?, public Status?) { }
}